module.exports = __webpack_public_path__ + "static/media/16.53eb25b8.jpg";